import React from 'react'
import { shallow } from 'enzyme'
import { PrepareHelloSignModal } from '../../modals/PrepareHelloSignModal'
import * as dependency from '../../helpers/EsignUtil'
import getPrepareEsignModalDocProps from "./data/PrepareEsignModalDocPropsTestData";
import getPrepareEsignModalProps from "./data/PrepareEsignModalPropsTestData";

describe('PrepareHelloSignModal', () => {
    let wrapper, instance, props, docProps
    beforeEach(() => {
        docProps = getPrepareEsignModalDocProps();
        props = getPrepareEsignModalProps(docProps);
        wrapper = shallow(<PrepareHelloSignModal {...props} />);

        instance = wrapper.instance();
    })
    describe('check the modal header', () => {
        it('should render the modal without error', () => {
            expect(wrapper).not.toBeNull();
            expect(wrapper.length).toEqual(1)
        });
        it('it should return obj', () => {
            const obj = wrapper.instance().render()
            expect(typeof obj).toBe('object')
        });
        test('it should have a root', () => {
            expect(wrapper.find('PrepareEsignModalElements__Container').length).toBe(1);
        })
        test('root should have a Header', () => {
            expect(wrapper.find('PrepareEsignModalElements__Header').length).toBe(1);
        })
        test('header should have a title with text', () => {
            expect(wrapper.find('PrepareEsignModalElements__Title').
              prop('children')).toEqual("Prepare Document for E-Sign");
        })
        test('header should have a close button', () => {
            expect(wrapper.find('PrepareEsignModalElements__Close').
            prop('children')).toEqual("X");
        })
        test('close should have a function to toggle the modal', () => {
            wrapper.find('PrepareEsignModalElements__Close').simulate('click');
            expect(props.toggleModal).toHaveBeenCalled();
        })
    });
    describe('check the modal body', () => {
        it('should render the body', () => {
            expect(wrapper.find('PrepareEsignModalElements__Body').length).toBe(1);
            expect(wrapper.length).toEqual(1)
        });
        it('body should have a hasTemplate property', () => {
            expect(wrapper.find('PrepareEsignModalElements__Body').prop('hasTemplate')).toBeTruthy();
        });
        it('Instruction text should reflect that a template is present', () => {
            expect(wrapper.find('#instructionText').prop('children')).toContain('We have a SmartBiz Template for this document');
        })
        it('Instruction text should reflect that a template is not present', () => {
            props.document.helloSignTemplateId = null;
            wrapper = shallow(<PrepareHelloSignModal {...props} />);
            expect(wrapper.find('#instructionText').prop('children')).toContain('No standard template is available for this type of document.');
        })
        it('displays document type selection', () => {
            expect(wrapper.find('PrepareEsignModalElements__DocumentTypeContainer').length).toBe(1);
        })
        it('displays two document type options', () => {
            expect(wrapper.find('PrepareEsignModalElements__DocumentTypeButton').length).toBe(2);
            expect(wrapper.find('PrepareEsignModalElements__DocumentTypeButton').find("#document_type_smartbiz_template").length).toBe(1);
            expect(wrapper.find('PrepareEsignModalElements__DocumentTypeButton').find("#document_type_custom").length).toBe(1);
            expect(wrapper.find('PrepareEsignModalElements__DocumentTypeButton').find('PrepareEsignModalElements__RadioInput').length).toBe(2);
        })
        it('shows cancel button if a document type provided', () => {
            expect(wrapper.find('PrepareEsignModalElements__Body').find("#cancel_prepare_esign").length).toBe(1);
        })
        it('shows prepare button if a document type provided', () => {
            expect(wrapper.find('PrepareEsignModalElements__Body').find("#prepare_esign").length).toBe(1);
        })
        it('does not render custom form if document type is not custom', () => {
            expect(wrapper.find('PrepareEsignModalElements__FileUploader').length).toBe(0);
        })
    });
    describe('custom form', () => {
        beforeEach(() => {
            props.document.helloSignTemplateId = null;
            wrapper.setProps(props)
            wrapper.setState({documentType: 'custom'})
        })
        it('renders custom form if document type is custom', () => {
            expect(wrapper.find('FileUploader').length).toBe(1);
        } )
    })
    describe('signers form', ()=> {
        describe('one signer', () => {
            it('displays signers form', () => {
                expect(wrapper.find('PrepareEsignModalElements__Signers').length).toBe(1);
            })
            it('displays a single signers form', () => {
                expect(wrapper.find('PrepareEsignModalElements__SignersForm').length).toBe(1);
            })
            it('it does not display an add signers button if not custom', () => {
                expect(wrapper.find('PrepareEsignModalElements__AddSigner').length).toBe(0);
            })
        });
        describe('two signers', () => {
            let signer_wrapper;
            let signer_instance;
            let signer_props;
            beforeEach(() => {
                docProps.esignSigners = [
                    {
                        email: "test@smartbizloans.com",
                        name: "People Person",
                        rid: "7890123",
                        role: 'signer_1',
                    },
                    {
                        email: "test2@smartbizloans.com",
                        name: "Purple People-eater",
                        rid: "7890124",
                        role: 'signer_1',
                    },
                ];
                signer_props = props;
                signer_props.document = docProps;

                signer_wrapper = shallow(<PrepareHelloSignModal {...signer_props} />);
                signer_wrapper.setState({signers : [
                    {
                        name: "People Person",
                        email: "test@smartbizloans.com",
                        role: "signer_1",
                    },
                    {
                        name: "Purple People-eater",
                        email: "test2@smartbizloans.com",
                        role: "signer_1",
                    },
                ]});
                signer_instance = signer_wrapper.instance();
            })
        })
    })
    describe('test esigning', () => {
        it('should start esign process', () => {
            dependency.openEsignModal = jest.fn();
            props.prepareEsign.mockReturnValue({data: { prepareEsign: { helloSign: { claimUrl:"http://www.amazon.com" } } }});
            instance.submitEsign().then(data => {
                expect(dependency.openEsignModal.mock.calls.length).toBe(1);
                expect(dependency.openEsignModal.mock.calls[0][0]).toStrictEqual({ clientId: '123456789', testMode: true });
                expect(dependency.openEsignModal.mock.calls[0][1]).toBe('send')
                expect(dependency.openEsignModal.mock.calls[0][2]).toStrictEqual(instance.messageListener)
                expect(dependency.openEsignModal.mock.calls[0][3]).toBe('http://www.amazon.com')
            });
        });
    });
});
